module.exports = __webpack_public_path__ + "static/media/edit-pencil.1f5566b3.svg";